import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { router } from './routes'
import { Loader } from '@/shared/components/Loader/Loader'

/**
 * Root App Component
 * 
 * This component is kept minimal and only handles routing.
 * All page content is handled by feature-based page components.
 * 
 * Performance: Suspense boundary for lazy-loaded routes
 */
function App() {
  return (
    <Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
          }}
        >
          <Loader text="Loading application..." />
        </div>
      }
    >
      <RouterProvider router={router} />
    </Suspense>
  )
}

export default App
